import React, { useState, useEffect } from "react";
import styles from "./login.module.css";
// import Redefining from "../Resources/Redefine_Results.svg";
import { Link } from "react-router-dom";
import { AiOutlineUser, AiOutlineLock } from "react-icons/ai";
import { connect, useDispatch } from "react-redux";
import {
  loginAction,
  loginFailedAction,
} from "../store/actions/AuthActions.js";
import Logo from "../assets/logo-with-text.svg";
import BgAnimation from "../assets/bg-animation2.mp4";

const Login = (props) => {
  const dispatch = useDispatch();
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (props.errorMessage != null) {
      setError(props.errorMessage);
      loginFailedAction(dispatch);
    }
  }, [props.errorMessage, dispatch]);

  // handle button click of login form
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    if (!username.length || !password.length) {
      setError("UserName and password are required!");
      setLoading(false);
    } else {
      setError(null);
      await dispatch(loginAction(username, password));
      setLoading(true);
    }
  };

  useEffect(() => {
    if (loading) {
      setLoading(true);
      const toRef = setTimeout(() => {
        setLoading(false);
        clearTimeout(toRef);
      }, 4000);
    }
  }, [loading]);

  return (
    <div className={`relative flex flex-col items-center lg:space-y-0 lg:flex-row min-h-screen w-full lg:items-center justify-center px-6 md:px-10 lg:px-0`}>
      <div>
        <video 
          autoPlay 
          loop 
          muted 
          playsInline
          webkit-playsinline="true"
          className="absolute inset-0 w-full h-full object-cover z-0 backdrop-blur-md"
          poster={BgAnimation}
        >
          <source src={BgAnimation} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="absolute inset-0 w-full h-full bg-black opacity-20 z-0"></div>
      </div>
      <div className="relative z-10 w-full md:w-auto rounded-[12px] md:rounded-[26px] shadow-custom-inner bg-gradient-to-br from-[#ffffff]/5 via-[#8BD89500] to-[#8BD89500] p-[1.5px]">
        <div className={` ${styles.loginBackground} w-full h-full flex flex-col p-[20px] md:p-[60px] rounded-[12px] md:rounded-[26px] shadow-custom-inner backdrop-blur-custom bg-transparent`}>
          <div className={`w-full flex items-center justify-center text-[24px] lg:text-[50px] lg:leading-[48px] font-bold font-poppins text-[#ffffff]  `}>
            <img src={Logo} alt="logo" className="w-[100px] md:w-[160px] lg:w-[220px]" />
          </div>
          <div className={`flex items-center mt-[40px] bg-[#ffffff0a] rounded-[6px]`}>
            <AiOutlineUser
              
              className={`ml-4 w-5 h-5  text-[#FEF35A]`}
            />
            <input
              type="text"
              value={username}
              onChange={(e) => setUserName(e.target.value)}
              placeholder="username"
              className={styles.logininput}
            />
          </div>
          <div className={`flex items-center mt-[40px] bg-[#ffffff0a] rounded-[6px]`}>
            <AiOutlineLock
               className={`ml-4 w-5 h-5  text-[#FEF35A]`}
            />
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="password"
              className={styles.logininput}
            />
          </div>
          <div className="flex flex-row justify-end w-full ">
            <div className={styles.checkbox}></div>
            <Link to="/forgot-password" className={styles.forgotText}>
              Forgot your password?
            </Link>
          </div>

          {error ? <div className={styles.errorMsg}>{error}</div> : null}

          {loading === true ? (
            <button className={styles.loginButton}>Authenticating...</button>
          ) : (
            <button className={`${styles.loginButton}`} onClick={handleSubmit}>
              Login
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    successMessage: state.auth.successMessage,
    errorMessage: state.auth.errorMessage,
  };
};

export default connect(mapStateToProps)(Login);
